import { createContext, useContext } from "react";

export interface RightPaneExpandContextValue {
  isExpanded: boolean;
  /** The pane is open AND expanded: it covers the canvas region. */
  isFullWidth: boolean;
  /** Current width of the right pane in px; 0 when closed. Used so canvas can constrain controls to visible area. */
  rightPanelWidth: number;
  /** Current width of the left (explorer) pane in px; 0 when closed. Used so canvas controls offset from the left. */
  leftPanelWidth: number;
  /**
   * Width (px) the canvas chat reserves on the LEFT when it docks beside a
   * full-width-expanded detail pane (0 otherwise). The right pane subtracts this
   * from its expanded width so the two sit side-by-side. Set by the chat (see
   * CanvasFloatingChatPanel), read by the right-pane width math — mirrors the
   * chat→toolbar `bottomToolbarRightClearancePx` signal in CanvasFloatingChatContext.
   */
  leftChatDockPx: number;
  setLeftChatDockPx: (px: number) => void;
  expandToMax: () => void;
  collapseToDefault: () => void;
}

const defaultValue: RightPaneExpandContextValue = {
  isExpanded: false,
  isFullWidth: false,
  rightPanelWidth: 0,
  leftPanelWidth: 0,
  leftChatDockPx: 0,
  setLeftChatDockPx: () => {},
  expandToMax: () => {},
  collapseToDefault: () => {},
};

export const RightPaneExpandContext =
  createContext<RightPaneExpandContextValue>(defaultValue);

export function useRightPaneExpandContext(): RightPaneExpandContextValue {
  return useContext(RightPaneExpandContext);
}
